import { PlayerDataGQL } from '../../../../Api'

export type SkillsParticipantsList = {
  fastestShot: PlayerDataGQL[]
  accuracy: PlayerDataGQL[]
  freestyle: PlayerDataGQL[]
  fastestPlayer: PlayerDataGQL[]
  goalie: PlayerDataGQL[]
  derby: PlayerDataGQL[]
}

export type UnleashedSkillsParticipantsList = {
  fastestShot: UnleashedPlayer[]
  accuracy: UnleashedPlayer[]
  freestyle: UnleashedPlayer[]
  fastestPlayer: UnleashedPlayer[]
  goalie: UnleashedPlayer[]
  derby: UnleashedPlayer[]
}

export type ChallengeItem = {
  name: string
  slug: SkillsKeys
  desc?: string
  winner: string
}

type SkillsList = {
  fastestShot: string[]
  accuracy: string[]
  freestyle: string[]
  goalie: string[]
  derby: string[]
}

type SkillsKeys = keyof SkillsList

type UnleashedSkillsList = {
  fastestShot: string[]
  accuracy: string[]
  freestyle: string[]
  goalie: string[]
  derby: string[]
}

type UnleashedSkillsKeys = keyof UnleashedSkillsList

export type UnleashedPlayer = {
  name: string
  slug: string
  profileUrl: string
  position: string
  currentTeam: {
    jerseyNum: number
    conference: string
  }
  yearsPro: number
}

export const skillsParticipants: SkillsList = {
  fastestShot: [
    'jarrod-neumann',
    'brennan-o-neill',
    'matt-campbell',
    'jake-piseno',
    'bryan-costabile',
  ],
  accuracy: [
    'marcus-holman',
    'jeff-teat',
    'mac-o-keefe',
    'grant-ament',
  ],
  freestyle: [
    'ryder-garnsey',
    'myles-jones',
    'jules-heningburg',
    'dox-aitken',
  ],
  goalie: ['blaze-riorden', 'brett-dobson', 'tim-troutner', 'colin-kirst'],
  derby: ['dox-aitken', 'ryan-drenner', 'tom-schreiber', 'piper-bond'],
}

export const unleashedSkillsParticipants: SkillsList = {
  fastestShot: ['charlotte-north', 'dana-dobbie', 'emily-hawryschuk', 'izzy-scane'],
  accuracy: ['charlotte-north', 'dana-dobbie', 'alex-aust-holman', 'izzy-scane'],
  freestyle: [],
  goalie: [],
  derby: ['charlotte-north', 'alex-aust-holman', 'emily-hawryschuk', 'izzy-scane'],
}

export const challengesArray: ChallengeItem[] = [
  {
    name: 'Air Gait Competition',
    slug: 'freestyle',
    desc: 'Each athlete will have 30s to score an air gait or crease dive style goal in the most creative way possible with 3 judges scoring.',
    winner: '',
  },
  {
    name: 'Accuracy Challenge',
    slug: 'accuracy',
    desc: 'The best shooters in the world take the stage to demonstrate accuracy, precision, and efficiency of shooting. 30 seconds, unlimited shots, and 5 targets of equal value. High score wins.',
    winner: '',
  },
  {
    name: 'Goalie Skills Challenge',
    slug: 'goalie',
    desc: 'The PLL’s top goalies compete through a combination of saving and clearing. Each save counts as one point, with clears of varying difficulty providing score multipliers. 52 second rounds. High score wins. One Round. Four Athletes.',
    winner: '',
  },
  {
    name: 'Fastest Shot',
    slug: 'fastestShot',
    desc: 'Who has the fastest shot in the PLL? Each athlete gets two attempts to hit the highest velocity. Fastest shot wins.',
    winner: '',
  },
  {
    name: 'Lacrosse Derby Challenge',
    slug: 'derby',
    desc: 'The Lacrosse Derby Challenge is a test of speed, agility, and precision. Participants sprint from one end to the top of the two-point line, navigate through an agility ladder and dodging course, then complete a wall ball sequence  before hitting a target. Two teams of four, each comprising 2 PLL pros and 2 unleashed pros, compete.',
    winner: '',
  },
]

export const getParticipants = (comp: SkillsKeys, players: PlayerDataGQL[]) => {
  let participants: PlayerDataGQL[] = []
  let list = skillsParticipants[comp]
  list.map((slug) => {
    let participant = players.find((pl) => pl.slug === slug)
    if (participant) {
      participants.push(participant)
    }
    return
  })
  return participants
}

export const getUnleashedParticipants = (
  comp: UnleashedSkillsKeys,
  players: UnleashedPlayer[]
) => {
  let participants: UnleashedPlayer[] = []
  let list = unleashedSkillsParticipants[comp]
  list.map((slug) => {
    let participant = players.find((pl) => pl.slug === slug)
    if (participant) {
      participants.push(participant)
    }
    return
  })
  return participants
}

export const unleashedPlayersList: UnleashedPlayer[] = [
  {
    name: 'Charlotte North',
    slug: 'charlotte-north',
    profileUrl: 'https://premierlacrosseleague.com/wp-content/uploads/2024/07/Charlotte-North.webp',
    position: 'A',
    currentTeam: {
      jerseyNum: 8,
      conference: 'eastern'
    },
    yearsPro: 3,
  },
  {
    name: 'Dana Dobbie',
    slug: 'dana-dobbie',
    profileUrl: 'https://premierlacrosseleague.com/wp-content/uploads/2024/07/Dana-Dobbie.webp',
    position: 'M',
    currentTeam: {
      jerseyNum: 27,
      conference: 'western'
    },
    yearsPro: 4,
  },
  {
    name: 'Alex Aust Holman',
    slug: 'alex-aust-holman',
    profileUrl: 'https://premierlacrosseleague.com/wp-content/uploads/2024/07/Alex.webp',
    position: 'A',
    currentTeam: {
      jerseyNum: 34,
      conference: 'eastern'
    },
    yearsPro: 5,
  },
  {
    name: 'Emily Hawryschuk',
    slug: 'emily-hawryschuk',
    profileUrl: 'https://premierlacrosseleague.com/wp-content/uploads/2024/07/Emily-E.webp',
    position: 'A',
    currentTeam: {
      jerseyNum: 51,
      conference: 'western'
    },
    yearsPro: 0,
  },
  {
    name: 'Izzy Scane',
    slug: 'izzy-scane',
    profileUrl: 'https://premierlacrosseleague.com/wp-content/uploads/2024/07/Izzy.webp',
    position: 'A',
    currentTeam: {
      jerseyNum: 27,
      conference: 'western'
    },
    yearsPro: 1,
  },
]
